var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.marquee && _vm.marquee.show)?_c('div',{staticClass:"marquee"},[(_vm.i18n.locale === 'en')?_c('marquee',[_vm._v(_vm._s(_vm.marquee.text_en || _vm.$t("noMarqueeText")))]):_vm._e(),(_vm.i18n.locale === 'pl')?_c('marquee',[_vm._v(_vm._s(_vm.marquee.text_pl || _vm.$t("noMarqueeText")))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }